import { useNavigate } from 'react-router-dom';
import { BackScreen } from '../../HemeIconLibrary';

function BackCmp() {
    const navigate = useNavigate();
    return ( 
        <button className='pr-4' onClick={() => navigate(-1)}><BackScreen/></button>
     );
}

export default BackCmp;